import { defineRecipe } from '@chakra-ui/react';

// v2 mapped size -> a responsive fontSize pair; v3 maps size -> the textStyle of
// the same name, shrinking every heading about two steps. Remapped through
// textStyle so it merges with v3's own size variant instead of fighting it.
//
// lineHeight has to come with it: v2's was unitless and scaled with an
// overridden fontSize (`<Heading size="xl" fontSize="lg">` = 21.6px), while v3's
// textStyle carries an absolute 2.75rem that survives the override (44px).
// Values below are v2's. They belong in the variant, not base — the variant's
// textStyle brings its own lineHeight and would win.
const headingRecipe = defineRecipe({
  // v2's Heading baseStyle was `bold`; v3's is `semibold`.
  base: { fontWeight: 'bold' },
  variants: {
    size: {
      xs: { textStyle: 'sm', lineHeight: 1.2 },
      sm: { textStyle: 'md', lineHeight: 1.2 },
      md: { textStyle: 'xl', lineHeight: 1.2 },
      lg: { textStyle: ['2xl', null, '3xl'], lineHeight: [1.33, null, 1.2] },
      xl: { textStyle: ['3xl', null, '4xl'], lineHeight: [1.33, null, 1.2] },
      '2xl': { textStyle: ['4xl', null, '5xl'], lineHeight: [1.2, null, 1] },
      '3xl': { textStyle: ['5xl', null, '6xl'], lineHeight: 1 },
      '4xl': { textStyle: ['6xl', null, '7xl'], lineHeight: 1 },
    },
  },
});

export default headingRecipe;
